import PropTypes from "prop-types";
import React from "react";
import { Dropdown, FormGroup, FormLabel } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { MAX_VALUE, RANGE_TYPE } from "../../../../utils/ValidatorUtils";
import QuestionHeader from "./QuestionHeader";

const Date = ({
  changeQuestionField,
  pageName,
  question,
  loadIndicators,
  setValidatorProperty,
  addIndicatorToQuestion,
  removeIndicatorFromQuestion,
  allIndicators,
  libraryQuestion
}) => {
  const intl = useIntl();
  return (
    <QuestionHeader
      changeQuestionField={changeQuestionField}
      pageName={pageName}
      question={question}
      intl={intl}
      addIndicatorToQuestion={addIndicatorToQuestion}
      removeIndicatorFromQuestion={removeIndicatorFromQuestion}
      loadIndicators={loadIndicators}
      allIndicators={allIndicators}
      libraryQuestion={libraryQuestion}
    >
      <ConfigComponent
        dateFormat={question.dateFormat ? question.dateFormat : "Day"}
        setValidatorProperty={setValidatorProperty}
        pageName={pageName}
        question={question}
        changeQuestionField={changeQuestionField}
      />
    </QuestionHeader>
  );
};

const ConfigComponent = ({ pageName, question, setValidatorProperty, dateFormat, editable=true }) => {
  const intl = useIntl();
  return (
    <FormGroup  className="mb-3">
      <FormLabel>Format</FormLabel>
      <Dropdown
        onSelect={(eventKey) => {
          setValidatorProperty(pageName, question.name, RANGE_TYPE, MAX_VALUE, eventKey, null);
        }}
      >
        <Dropdown.Toggle id="calendarChoices" disabled={!editable}>
          {dateFormat
            ? intl.formatMessage({ id: "survey.editor.date." + dateFormat.toLowerCase() })
            : question.dateFormat
            ? intl.formatMessage({ id: "survey.editor.date." + question.dateFormat.toLowerCase() })
            : intl.formatMessage({ id: "survey.editor.date.day" })}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item eventKey="Year">{<FormattedMessage id="survey.editor.date.year" />}</Dropdown.Item>
          <Dropdown.Item eventKey="Month">{<FormattedMessage id="survey.editor.date.month" />}</Dropdown.Item>
          <Dropdown.Item eventKey="Day">{<FormattedMessage id="survey.editor.date.day" />}</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </FormGroup>
  );
};

Date.Config = ConfigComponent;

ConfigComponent.propTypes = {
  question: PropTypes.object,
  pageName: PropTypes.string,
  setValidatorProperty: PropTypes.func,
  dateFormat: PropTypes.string,
  intl: PropTypes.object
};

Date.propTypes = {
  changeQuestionField: PropTypes.func,
  pageName: PropTypes.string,
  question: PropTypes.object,
  intl: PropTypes.object,
  allIndicators: PropTypes.array,
  setValidatorProperty: PropTypes.func,
  addIndicatorToQuestion: PropTypes.func,
  removeIndicatorFromQuestion: PropTypes.func,
  loadIndicators: PropTypes.func,
  dateFormat: PropTypes.string,
  libraryQuestion: PropTypes.object
};
export default Date;
